import { Controller } from '@hotwired/stimulus'
import { applyLeadFinderSearchFilters } from '../lead_finder/apply_search_filters'

export default class extends Controller {
  static values = {
    filters: Object,
    autoSearch: { type: Boolean, default: false }
  }

  connect() {
    if (!this.filtersValue || Object.keys(this.filtersValue).length === 0) return

    const shouldAutoSearch = this.autoSearchValue
    setTimeout(() => {
      applyLeadFinderSearchFilters(this.filtersValue)
      document.dispatchEvent(new CustomEvent('filters-changed', { bubbles: true }))
      document.dispatchEvent(new CustomEvent('values-changed', { bubbles: true }))

      if (shouldAutoSearch) this.submitSearch()

      this.element.remove()
    }, 150)
  }

  // Chips land via bulk-add-values; Alpine must recount before Search is
  // enabled. Retry until hidden value inputs exist, then submit.
  submitSearch(attempt = 0) {
    const form = document.getElementById('lead_finder_form')
    if (!form) return

    const hasValues = form.querySelectorAll('input[name$="[values][]"]').length > 0
    if (!hasValues && attempt < 20) {
      setTimeout(() => this.submitSearch(attempt + 1), 50)
      return
    }

    const button = form.querySelector('button[type="submit"]')
    if (button) {
      button.disabled = false
      button.removeAttribute('disabled')
      button.click()
      return
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }
}
